import { deviceDashboardTypes } from "../actions/deviceDashboard";
import { authTypes } from "../actions/auth";
const initialDate = new Date();

const initialState = {
  currentId: "",
  isRefresh: false,
  isLoading: {
    rssiHistory: false,
    locationHistory: false,
    signalHistory: false,
    batteryHistory: false,
    accelerationHistory: false,
    gatewayTelemetryHistory: false,
    assetHistory: false,
    shockAlarmHistory: false,
  },
  resolutionFilters: {
    rssi: {
      duration: "7 days",
      resolution: "15 minutes",
    },
    battery: {
      duration: "7 days",
      resolution: "15 minutes",
    },
    signalStrength: {
      duration: "7 days",
      resolution: "15 minutes",
    },
    acceleration: {
      duration: "7 days",
      resolution: "15 minutes",
    },
    shockAlarm: {
      duration: "7 days",
      resolution: "15 minutes",
    },
  },
  isFullScreenMode: false,
  displayOpt: "most_recent",
  // selectedDateTime: `${initialDate.getFullYear()}-${
  //   (initialDate.getMonth() + 1).toString()
  //   .padStart(2, "0")
  // }-${initialDate
  //   .getDate()
  //   .toString()
  //   .padStart(2, "0")}T${initialDate.toLocaleTimeString({
  //   hour12: false,
  // })}`,
  selectedDateTime: `${initialDate.getFullYear()}-${
    (initialDate.getMonth() + 1).toString()
    .padStart(2, "0")
  }-${initialDate
    .getDate()
    .toString()
    .padStart(2, "0")} ${initialDate.toLocaleTimeString({
    hour12: false,
  })?.replace(/AM|PM/,'')}`,
  resolutionTime: 15 * 60 * 1000,
  data: {
    rssiHistory: [],
    locationHistory: [],
    signalHistory: [],
    batteryHistory: {
      timeAgo: "",
      battery: [],
    },
    accelerationHistory: {
      accelerationX: [],
      accelerationY: [],
      accelerationZ: [],
      accelerationRMS: [],
    },
    gatewayTelemetryHistory: [],
    assetHistory: [],
    shockAlarmHistory: {
      timeAgo: "",
      shock: [],
    },
  },
  error: {
    shockAlarmHistory: null,
  },
};

const deviceDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case deviceDashboardTypes.UPDATE_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case deviceDashboardTypes.FETCH_RSSI_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        isLoading: {
          ...state.isLoading,
          rssiHistory: true
        },
        resolutionFilters:
          action.payload.resolutionFilterKey && action.payload.resolutionFilter
            ? {
                ...state.resolutionFilters,
                [action.payload.resolutionFilterKey]:
                  action.payload.resolutionFilter,
              }
            : state.resolutionFilters,
      };
    case deviceDashboardTypes.FETCH_LOCATION_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        isLoading: {
          ...state.isLoading,
          locationHistory: true
        }
      };
    case deviceDashboardTypes.FETCH_SIGNAL_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        isLoading: {
          ...state.isLoading,
          signalHistory: true
        },
        resolutionFilters:
          action.payload.resolutionFilterKey && action.payload.resolutionFilter
            ? {
                ...state.resolutionFilters,
                [action.payload.resolutionFilterKey]:
                  action.payload.resolutionFilter,
              }
            : state.resolutionFilters,
      };
    case deviceDashboardTypes.FETCH_BATTERY_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        isLoading: {
          ...state.isLoading,
          batteryHistory: true
        },
        resolutionFilters:
          action.payload.resolutionFilterKey && action.payload.resolutionFilter
            ? {
                ...state.resolutionFilters,
                [action.payload.resolutionFilterKey]:
                  action.payload.resolutionFilter,
              }
            : state.resolutionFilters,
      };
    case deviceDashboardTypes.FETCH_ACCLERATION_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        isLoading: {
          ...state.isLoading,
          accelerationHistory: true
        },
        resolutionFilters:
          action.payload.resolutionFilterKey && action.payload.resolutionFilter
            ? {
                ...state.resolutionFilters,
                [action.payload.resolutionFilterKey]:
                  action.payload.resolutionFilter,
              }
            : state.resolutionFilters,
      };
    case deviceDashboardTypes.FETCH_GATEWAY_TELEMETRY_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        isLoading: {
          ...state.isLoading,
          gatewayTelemetryHistory: true,
        }
      };
      case deviceDashboardTypes.FETCH_ASSET_HISTORY_REQUEST:
        return {
          ...state,
          currentId: action.payload.id,
          isLoading: {
            ...state.isLoading,
            assetHistory: true,
          }
        };
      case deviceDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_REQUEST:
        return {
          ...state,
          currentId: action.payload.id,
          isLoading: {
            ...state.isLoading,
            shockAlarmHistory: true,
          },
          error: {
            ...state.error,
            shockAlarmHistory: null,
          },
          resolutionFilters:
            action.payload.resolutionFilterKey && action.payload.resolutionFilter
              ? {
                  ...state.resolutionFilters,
                  [action.payload.resolutionFilterKey]:
                    action.payload.resolutionFilter,
                }
              : state.resolutionFilters,
        };
    case deviceDashboardTypes.FETCH_RSSI_HISTORY_SUCCESS:
      return {
        ...state,
        isRefresh: false,
        isLoading: {
          ...state.isLoading,
          rssiHistory: false,
        },
        data: {
          ...state.data,
          rssiHistory: action.payload,
        },
        error: {
          rssiHistory: null,
        },
      };
    case deviceDashboardTypes.FETCH_RSSI_HISTORY_FAILURE:
      return {
        ...state,
        isRefresh: false,
        isLoading: {
          ...state.isLoading,
          rssiHistory: false,
        },
        error: {
          rssiHistory: action.payload,
        },
      };
    case deviceDashboardTypes.FETCH_LOCATION_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          locationHistory: false,
        },
        data: {
          ...state.data,
          locationHistory: action.payload,
        },
        error: {
          locationHistory: null,
        },
      };
    case deviceDashboardTypes.FETCH_LOCATION_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          locationHistory: false,
        },
        error: {
          locationHistory: action.payload,
        },
      };
    case deviceDashboardTypes.FETCH_BATTERY_HISTORY_SUCCESS:
      return {
        ...state,
        isRefresh: false,
        isLoading: {
          ...state.isLoading,
          batteryHistory: false,
        },
        data: {
          ...state.data,
          batteryHistory: action.payload,
        },
        error: {
          batteryHistory: null,
        },
      };
    case deviceDashboardTypes.FETCH_BATTERY_HISTORY_FAILURE:
      return {
        ...state,
        isRefresh: false,
        isLoading: {
          ...state.isLoading,
          batteryHistory: false,
        },
        error: {
          batteryHistory: action.payload,
        },
      };
    case deviceDashboardTypes.FETCH_ACCLERATION_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          accelerationHistory: false,
        },
        data: {
          ...state.data,
          accelerationHistory: action.payload,
        },
        error: {
          accelerationHistory: null,
        },
      };
    case deviceDashboardTypes.FETCH_ACCLERATION_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          accelerationHistory: false,
        },
        error: {
          accelerationHistory: action.payload,
        },
      };
    case deviceDashboardTypes.FETCH_GATEWAY_TELEMETRY_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          gatewayTelemetryHistory: false,
        },
        data: {
          ...state.data,
          gatewayTelemetryHistory: action.payload,
        },
        error: {
          gatewayTelemetryHistory: null,
        },
      };
    case deviceDashboardTypes.FETCH_GATEWAY_TELEMETRY_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          gatewayTelemetryHistory: false,
        },
        error: {
          gatewayTelemetryHistory: action.payload,
        },
      };
      case deviceDashboardTypes.FETCH_ASSET_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetHistory: false,
        },
        data: {
          ...state.data,
          assetHistory: action.payload,
        },
        error: {
          assetHistory: null,
        },
      };
    case deviceDashboardTypes.FETCH_ASSET_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetHistory: false,
        },
        error: {
          assetHistory: action.payload,
        },
      };
    case deviceDashboardTypes.FETCH_SIGNAL_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          signalHistory: false,
        },
        data: {
          ...state.data,
          signalHistory: action.payload,
        },
        error: {
          signalHistory: null,
        },
      };
    case deviceDashboardTypes.FETCH_SIGNAL_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          signalHistory: false,
        },
        error: {
          signalHistory: action.payload,
        },
      };
    case deviceDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_SUCCESS:
      // Saga already sends the data in the correct format: { timeAgo, shock: [[timestamp, magnitude, payload]] }
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shockAlarmHistory: false,
        },
        data: {
          ...state.data,
          shockAlarmHistory: {
            timeAgo: action.payload.timeAgo || "",
            shock: action.payload.shock || [],
          },
        },
        error: {
          ...state.error,
          shockAlarmHistory: null,
        },
      };
    case deviceDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shockAlarmHistory: false,
        },
        error: {
          ...state.error,
          shockAlarmHistory: action.payload,
        },
      };
    case authTypes.LOGOUT:
    case authTypes.AUTO_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default deviceDashboardReducer;
